import React, { useEffect, useRef, useState } from 'react';
import { post } from '../Auths/AuthToken';
import CounselingAccordion from './CounselingAccordion';
import CounselingSecColSubChild from './CounselingSecColSubChild';
import CounselingSecColSubChildUnRegister from './CounselingSecColSubChildUnRegister';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import SubTypePopup from './SubTypePopup';
import setUiMessage from '../../Utilities/Tostify';
import AddSubValPopup from './AddSubValPopup';
import CopyFromLastVisitDropDown from '../../Utilities/CopyFromLastVisitDropDown';
import { handleCounsellingFormMidItem } from '../../httpdata/appointmentsdata';
import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button';

function BioPsychoSocialPopUp({
  handleClose,
  patientId,
  soapId,
  appId,
  visitId,
  handleReload,
}) {
  const [allData, setAllData] = useState([]);
  const [bpsiId, setBpsiId] = useState(false);
  const [textAreaData, setTextAreaDataData] = useState({});
  const [showHideChiled, setShowHideChiled] = useState('1_2');
  const [classFirstCol, setClassFirstCol] = useState('1_2');
  const [catAndId, setCatAndId] = useState('1_2');
  const [accord, seAccord] = useState({});
  const [childId, setChildId] = useState('');
  const [checkedAll, setCheckedAll] = useState({});
  const [checkBoxData, setCheckBoxData] = useState({});
  const [childSerch, setChildSerch] = useState({});
  const [removeSubChild, setRemoveSubChild] = useState(false);
  const [addSubChild, setAddSubChild] = useState(false);
  const [sucPrams, setSucPrams] = useState('');

  const [subTypePopup, setSubTypePopup] = useState(false);
  const [subChildPrams, setSubChildPrams] = useState([]);

  const [editSubChild, setEditSubChild] = useState({
    status: false,
    data: null,
  });
  const [lastVisitData, setLastVisitData] = useState('');

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);

  const scrollRefs = useRef([]);
  const checkboxRef = useRef([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/openBioPsychosocialIntakePopup',
          {
            patientId: patientId,
            soapId: soapId,
            appId: appId,
            visitId: visitId,
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
          setBpsiId(response?.data?.bpsiId);
          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `bpsiDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = subData[3];
              });
              return acc;
            },
            {}
          );
          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setChildId(`${data[3]}_${subData[0]}`);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (subData[4] === 'race') {
                    for (let f in response?.data?.races) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.races[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'ethnicity') {
                    for (let f in response?.data?.ethnicitys) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.ethnicitys[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'sex_orient') {
                    for (let f in response?.data?.sexos) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.sexos[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'cur_past_med_cond') {
                    for (let f in response?.data?.diseaseList) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.diseaseList[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'surg_hosp') {
                    for (let f in response?.data?.surgList) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.surgList[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'pres_med') {
                    for (let f in response?.data?.activeMeds) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.activeMeds[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'pcp') {
                    for (let f in response?.data?.getDoctorNameList) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.getDoctorNameList[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'dx') {
                    for (let f in response?.data?.generalProbArr) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.generalProbArr[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  subData[2] &&
                    subData[2]?.forEach((subChildData) => {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                      acc[key] =
                        subChildData?.is_checked === '1' ? true : false;
                    });
                });
              return acc;
            },
            {}
          );
          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, soapId, appId, visitId]);

  const handleBpsiFormSave = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/saveBpsiCounclForm',
        {
          patientId: patientId,
          soapId: soapId,
          appId: appId,
          visitId: visitId,
          staffUserId: user?.id,
          bpsiDataJson: getBpsiJson(),
        }
      );
      if (response.status === 200) {
        handleClose();
        handleReload('biopsycho');
        dispatch(
          setRenderFormData({
            data: {
              genDetail: response.data.genDetail,
              biopsychosocialIntakeData: response.data.renderBpsiData,
            },
            type: 'biopsycho',
          })
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleBpsiFormUpdate = async () => {
    try {
      const response = await post('api/patient/progressNote/updateBpsilForm', {
        patientId: patientId,
        soapId: soapId,
        appId: appId,
        bpsiId: bpsiId,
        visitId: visitId,
        staffUserId: user?.id,
        bpsiDataJson: getBpsiJson(),
      });
      if (response.status === 200) {
        handleClose();
        handleReload('biopsycho');

        dispatch(
          setRenderFormData({
            data: {
              genDetail: response.data.genDetail,
              biopsychosocialIntakeData: response.data.renderBpsiData,
            },
            type: 'biopsycho',
          })
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const getBpsiJson = () => {
    let masterArr = [];
    let hisAndSymMaster = document.querySelectorAll('.bpsiAddEditSection');
    let retStr = false;
    if (hisAndSymMaster) {
      hisAndSymMaster.forEach(function (element) {
        const masterId = element.getAttribute('value');
        let masterText = document.querySelector(
          '#bpsiDetailsText_' + masterId
        ).value;

        let hisAndSymChield = document.querySelectorAll(
          '.bpsiMasterSubChildData_' + masterId
        );

        let childArr = [];
        hisAndSymChield.forEach(function (element, i) {
          let childIdTextArr = element.getAttribute('id').split('_');
          let subTypeVal = element.getAttribute('attr')
            ? element.getAttribute('attr')
            : '0';
          let childText = document.getElementById(
            'bpsiSubChildDataList_' + masterId + '_' + childIdTextArr[3]
          ).textContent;

          childArr.push({
            masterId: masterId,
            childId: childIdTextArr[3],
            childText: childText.trim(),
            childInput: checkBoxData[element.getAttribute('id')] ? '1' : '0', //isChecked ? '1' : '0',
            childSubKey: subTypeVal,
          });
        });
        masterArr.push({
          masterId: masterId,
          masterText: masterText,
          childArr: childArr,
        });
      });
      retStr = JSON.stringify(masterArr);
    }
    return retStr;
  };

  const handleTextAreaChange = (e) => {
    const { name, value } = e.target;
    setTextAreaDataData({ ...textAreaData, [name]: value });
  };

  const handleSubDataShow = (id) => {
    setShowHideChiled(id);
    setClassFirstCol(id);
    setCatAndId(id);
    setChildId(id);
    const allElements = document.querySelectorAll('.cnslng-actv-area');
    allElements.forEach((element) => {
      element.classList.remove('cnslng-actv-area');
    });
    const target = scrollRefs.current['bpsiDetailsText_' + id];
    target.scrollIntoView({ behavior: 'smooth' });
    target.className = 'cnslng-actv-area';
  };

  const selectAll = (e, id) => {
    const { checked } = e.target;
    setCheckedAll({ ...checkedAll, [id]: checked ? true : false });

    let secColdata = document.querySelectorAll('.bpsiMasterSubChildData_' + id);
    let finalText = '';
    secColdata.forEach(function (element, i) {
      let idArr = element.getAttribute('id').split('_');
      let selStr = document.getElementById(
        'bpsiSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3]
      ).textContent;

      if (checked) {
        checkBoxData[element.getAttribute('id')] = checked;
        finalText += selStr + '\n';
      } else {
        checkBoxData[element.getAttribute('id')] = checked;
      }
    });
    finalText = finalText.slice(0, -2);
    setTextAreaDataData({
      ...textAreaData,
      ['bpsiDetailsText_' + id]: finalText,
    });
  };

  const handleChildSerch = (e, id) => {
    const { value } = e.target;
    setChildSerch({});
    setChildSerch({ ...childSerch, [id]: value });
  };

  useEffect(() => {
    let userInput = childSerch[catAndId]?.replace(/\\/g, '').toLowerCase();
    let secCol = document.querySelectorAll(
      '.bpsiMasterSubChildData_' + catAndId
    );
    secCol.forEach(function (element, i) {
      let searchTerm = element.getAttribute('data-search-term').toLowerCase();
      if (searchTerm.search(userInput) === -1) {
        element.classList.add('hide');
      } else {
        element.classList.remove('hide');
      }
    });
  }, [childSerch, catAndId]);

  const handleSubTypePopup = (data) => {
    setSubTypePopup(true);
  };

  const handleCheckBoxLable = (eleId, data) => {
    if (data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([eleId, data]);
    } else {
      const target = checkboxRef.current[eleId];
      let checked = !target.checked;
      handleCheckBoxChangeComn(eleId, checked);
      setCheckBoxData({
        ...checkBoxData,
        [eleId]: checked ? true : false,
      });
    }
  };

  const handleCheckBoxChange = (e, data) => {
    const { id, checked } = e.target;
    if (checked && data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([e.target.id, data]);
      setCheckBoxData({
        ...checkBoxData,
        [e.target.id]: true,
      });
    } else {
      setCheckBoxData({
        ...checkBoxData,
        [id]: checked ? true : false,
      });

      handleCheckBoxChangeComn(id, checked);
    }
  };

  const handleCheckBoxChangeComn = (id, checked) => {
    const idArr = id?.split('_');

    let selStr = document?.querySelector(
      '#bpsiSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3]
    ).textContent;
    let resSelStr = document?.querySelector(
      '#bpsidiagReason_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3]
    ).textContent;

    if (resSelStr !== 'undefined') {
      selStr += resSelStr ? '\n' + resSelStr : '';
    }

    setChildId(idArr[1] + '_' + idArr[2]);
    let textData = textAreaData['bpsiDetailsText_' + idArr[1] + '_' + idArr[2]];
    if (checked) {
      textData = textData?.replace(selStr, '');
      textData = textData?.replace(/^,*\s*|,*\s*$/, '');
      setTextAreaDataData({
        ...textAreaData,
        ['bpsiDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
          ? textData + '\n' + selStr
          : selStr,
      });
    } else {
      if (textData?.indexOf('\n' + selStr) === -1) {
        textData = textData?.replace(selStr + '\n', '');
      } else {
        textData = textData?.replace('\n' + selStr, '');
      }
      textData = textData?.replace(selStr, '');
      textData?.replace(/^,*\s*|,*\s*$/, '');
      setTextAreaDataData({
        ...textAreaData,
        ['bpsiDetailsText_' + idArr[1] + '_' + idArr[2]]: textData,
      });
    }
  };

  useEffect(() => {
    if (childId) {
      let allChecked = true;
      const newObj = {};
      // const spl = childId?.split('_');
      for (const key in checkBoxData) {
        if (key.startsWith('bpsiSubChildDataListInpt_' + childId + '_')) {
          newObj[key] = checkBoxData[key];
        }
      }
      for (const i in newObj) {
        if (newObj[i] === false) {
          allChecked = false;
        }
      }

      Object.keys(newObj).length !== 0 &&
        setCheckedAll((prevState) => ({
          ...prevState,
          [childId]: allChecked,
        }));
    }
  }, [checkBoxData, childId]);

  const handleRemoveSubChild = (id) => {
    setRemoveSubChild(true);
    setSucPrams(id);
  };
  const handleEditSubChild = (id) => {
    setEditSubChild({ ...editSubChild, status: true, data: id });
  };

  const handleRemoveSubChildConfirm = async (id) => {
    const idArr = id.split('_');
    const itemId = idArr[2];
    if (itemId) {
      const response = await handleCounsellingFormMidItem(itemId, 'bpsi');
      if (response?.status === 200) {
        if (response.data.message === 'success') {
          setUiMessage('suc', 'Record deleted successfully.');
          setCheckBoxData({
            ...checkBoxData,
            ['bpsiSubChildDataListInpt_' + id]: false,
          });
          const split = id?.split('_');

          const selStr = document?.querySelector(
            '#bpsiSubChildDataList_' + id
          ).innerHTML;
          setChildId(split[0] + '_' + split[1]);

          let textData =
            textAreaData['bpsiDetailsText_' + split[0] + '_' + split[1]];

          if (textData?.indexOf('\n' + selStr) === -1) {
            textData = textData?.replace(selStr + '\n', '');
          } else {
            textData = textData?.replace('\n' + selStr, '');
          }

          //textData = textData?.replace(selStr, '');
          textData?.replace(/^,*\s*|,*\s*$/, '');
          setTextAreaDataData({
            ...textAreaData,
            ['bpsiDetailsText_' + split[0] + '_' + split[1]]: textData,
          });

          const element = document.querySelector(
            '#bpsiSubChildDataListInpt_' + id
          );
          element.remove();
          setRemoveSubChild(false);
        }
      } else {
        setUiMessage('err', 'Something went wrong.');
      }
    }
  };

  const handlesubtypeform = (id, data) => {
    const idArr = id?.split('_');
    let textData = textAreaData['bpsiDetailsText_' + idArr[1] + '_' + idArr[2]];
    //if (checked) {
    textData = textData?.replace(data, '');
    textData = textData?.replace(/^,*\s*|,*\s*$/, '');
    setTextAreaDataData({
      ...textAreaData,
      ['bpsiDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
        ? textData + '\n' + data
        : data,
    });
    // }

    setCheckBoxData({
      ...checkBoxData,
      [id]: true,
    });
  };

  const handleCalbackData = (data, catagory, i, j, subTypeSection, mode) => {
    setCheckBoxData({
      ...checkBoxData,
      [`bpsiSubChildDataListInpt_${data[0]}_${data[1]}_${data[2]}`]: false,
    });
    const updatedData = [...allData?.therapyMasterData];
    if (mode === 'add') {
      const newObj = {
        child_id: data[2],
        child_texte: catagory,
        sub_type: subTypeSection ? '1' : '0',
      };
      updatedData[i][2][j][2].push(newObj);
    } else {
      const newObjIndex = updatedData[i][2][j][2].findIndex(
        (obj) => obj.child_id === data[2]
      );
      if (newObjIndex !== -1) {
        updatedData[i][2][j][2][newObjIndex].child_texte = catagory;
        updatedData[i][2][j][2][newObjIndex].sub_type = subTypeSection
          ? '1'
          : '0';
        // You can update other properties as well
      }
    }
    //setAllData(updatedData);
  };

  const handleReStoreLastVisitData = (data) => {
    setLastVisitData(data);
    let args = data.split('_');
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/openBioPsychosocialIntakePopup',
          {
            patientId: patientId,
            soapId: args[0],
            appId: args[1],
            visitId: args[2],
          }
        );
        if (response.status === 200) {
          setAllData((lastData) => ({
            ...lastData,
            diseaseList: response?.data?.diseaseList,
            //activeMeds: response?.data?.activeMeds,
            //generalProbArr: response?.data?.generalProbArr,
            lastVisArr: response?.data?.lastVisArr,
            patActProbList: response?.data?.patActProbList,
            prefProbList: response?.data?.prefProbList,
            soapDetail: response?.data?.soapDetail,
            surgList: response?.data?.surgList,
            therapyMasterData: response?.data?.therapyMasterData,
          }));

          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `bpsiDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = subData[3] || '';
              });
              return acc;
            },
            {}
          );
          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setChildId(`${data[3]}_${subData[0]}`);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (subData[4] === 'race') {
                    for (let f in response?.data?.races) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.races[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'ethnicity') {
                    for (let f in response?.data?.ethnicitys) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.ethnicitys[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'sex_orient') {
                    for (let f in response?.data?.sexos) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.sexos[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'cur_past_med_cond') {
                    for (let f in response?.data?.diseaseList) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.diseaseList[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'surg_hosp') {
                    for (let f in response?.data?.surgList) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.surgList[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'pres_med') {
                    for (let f in response?.data?.activeMeds) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.activeMeds[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'pcp') {
                    for (let f in response?.data?.getDoctorNameList) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.getDoctorNameList[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  if (subData[4] === 'dx') {
                    for (let f in response?.data?.generalProbArr) {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.generalProbArr[f]?.id}`;
                      acc[key] = false;
                    }
                  }

                  subData[2] &&
                    subData[2]?.forEach((subChildData) => {
                      const key = `bpsiSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                      acc[key] =
                        subChildData?.is_checked === '1' ? true : false;
                    });
                });
              return acc;
            },
            {}
          );
          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleCloseFun = (type) => {
    if (type === 'silent') {
      handleClose();
      return;
    }
    if (allData?.mode === 'add') {
      handleBpsiFormSave();
    } else if (allData?.mode === 'update') {
      handleBpsiFormUpdate();
    }
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr center-popup" style={{ width: '95%' }}>
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">Intake:</span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs-[{allData?.gender?.slice(0, 1)}]
            <span className="red"> | </span>
            DOB:{allData?.dob}
          </div>
          <div className="hdr-pt-info" style={{ width: '24%' }}>
            <CopyFromLastVisitDropDown
              dataArr={allData}
              selectedVal={lastVisitData}
              calback={(selectedOption) =>
                handleReStoreLastVisitData(selectedOption?.value)
              }
            />
            {/* <select
              className="book-appt-dd"
              value={lastVisitData}
              onChange={(e) => handleReStoreLastVisitData(e.target.value)}
            >
              <option value="">{''}</option>
              {allData?.lastVisArr?.map((data, i) => (
                <option
                  key={i}
                  value={`${data?.soapId}_${data?.appointment_id}_${data?.visitId}`}
                >
                  {`${data?.consultDate} - ${data?.resName.substr(0, 6)}...`}
                </option>
              ))}
            </select> */}
          </div>
          <Button variant="circle" onClick={() => handleCloseFun()}>
            X
          </Button>
        </div>
        <div className="main-contnr-bdy mat-cnslng-fu-bdy flex-sec">
          <div className="mat-cnslng-col1">
            {allData?.therapyMasterData?.map((data, r) => (
              <CounselingAccordion
                key={r}
                classFirstCol={classFirstCol}
                accord={accord}
                handleSubDataShow={handleSubDataShow}
                parent={data}
                handleClick={(id) => {
                  seAccord(data[3]);
                  handleSubDataShow(data[3] + '_' + data[2][0][0]);
                }}
                moduleName={'bpsiAddEditSection'}
              />
            ))}
          </div>
          <div className="mat-cnslng-col2">
            {allData?.therapyMasterData?.map((data, i) => (
              <div key={i}>
                {data[2] &&
                  data[2]?.map((subData, j) => (
                    <div
                      key={j}
                      id={'bpsiSubChildBox_' + data[3] + '_' + subData[0]}
                      className={
                        showHideChiled === data[3] + '_' + subData[0]
                          ? ''
                          : 'hide'
                      }
                      style={{ height: '100%' }}
                    >
                      <div className="sec-col-serch">
                        <span className="clear5 clear-left10">
                          <input
                            type="checkbox"
                            checked={checkedAll[data[3] + '_' + subData[0]]}
                            onChange={(e) =>
                              selectAll(e, data[3] + '_' + subData[0])
                            }
                          />
                        </span>
                        <span className="clear-left10">
                          <input
                            type="search"
                            className="cnslng-fu-chld-srch"
                            placeholder="Search here..."
                            value={childSerch[data[3] + '_' + subData[0]] || ''}
                            onChange={(e) =>
                              handleChildSerch(e, data[3] + '_' + subData[0])
                            }
                          />
                          {subData[4] !== 'race' &&
                          subData[4] !== 'ethnicity' &&
                          subData[4] !== 'sex_orient' &&
                          subData[4] !== 'cur_past_med_cond' &&
                          subData[4] !== 'pres_med' &&
                          subData[4] !== 'pcp' &&
                          subData[4] !== 'surg_hosp' &&
                          subData[4] !== 'dx' ? (
                            <span
                              className="add-new-chld-item"
                              id=""
                              title="Add new values"
                              onClick={() => setAddSubChild(true)}
                            >
                              +
                            </span>
                          ) : (
                            ''
                          )}

                          {addSubChild && (
                            <AddSubValPopup
                              closeDialog={() => setAddSubChild(false)}
                              masCatId={data[3]}
                              masterId={subData[0]}
                              childId={''}
                              handleCalbackData={handleCalbackData}
                              catIndex={i}
                              subCatIndex={j}
                              formName="bpsi"
                              heading={subData[1]}
                            />
                          )}
                          {editSubChild.status && (
                            <AddSubValPopup
                              closeDialog={() =>
                                setEditSubChild({
                                  ...editSubChild,
                                  status: false,
                                })
                              }
                              masCatId={data[3]}
                              masterId={subData[0]}
                              childId={editSubChild?.data[2]}
                              handleCalbackData={handleCalbackData}
                              catIndex={i}
                              subCatIndex={j}
                              formName="bpsi"
                              heading={subData[1]}
                              cat={editSubChild?.data[3]}
                            />
                          )}
                        </span>
                      </div>
                      {(subData[4] === 'race' && allData?.races && (
                        <CounselingSecColSubChildUnRegister
                          data={data}
                          subData={subData}
                          checkBoxData={checkBoxData}
                          handleCheckBoxChange={handleCheckBoxChange}
                          handleRemoveSubChild={handleRemoveSubChild}
                          moduleName={'bpsi'}
                          allData={allData?.races}
                          checkboxRef={checkboxRef}
                          handleCheckBoxLable={handleCheckBoxLable}
                        />
                      )) ||
                        (subData[4] === 'ethnicity' && allData?.ethnicitys && (
                          <CounselingSecColSubChildUnRegister
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            moduleName={'bpsi'}
                            allData={allData?.ethnicitys}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )) ||
                        (subData[4] === 'sex_orient' && allData?.sexos && (
                          <CounselingSecColSubChildUnRegister
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            moduleName={'bpsi'}
                            allData={allData?.sexos}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )) ||
                        (subData[4] === 'cur_past_med_cond' &&
                          allData?.diseaseList && (
                            <CounselingSecColSubChildUnRegister
                              data={data}
                              subData={subData}
                              checkBoxData={checkBoxData}
                              handleCheckBoxChange={handleCheckBoxChange}
                              handleRemoveSubChild={handleRemoveSubChild}
                              moduleName={'bpsi'}
                              allData={allData?.diseaseList}
                              checkboxRef={checkboxRef}
                              handleCheckBoxLable={handleCheckBoxLable}
                            />
                          )) ||
                        (subData[4] === 'surg_hosp' && allData?.surgList && (
                          <CounselingSecColSubChildUnRegister
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            moduleName={'bpsi'}
                            allData={allData?.surgList}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )) ||
                        (subData[4] === 'pcp' && allData?.getDoctorNameList && (
                          <CounselingSecColSubChildUnRegister
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            moduleName={'bpsi'}
                            allData={allData?.getDoctorNameList}
                            both={true}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )) ||
                        (subData[4] === 'pres_med' && allData?.activeMeds && (
                          <CounselingSecColSubChildUnRegister
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            moduleName={'bpsi'}
                            allData={allData?.activeMeds}
                            both={true}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )) ||
                        (subData[4] === 'dx' && allData?.generalProbArr && (
                          <CounselingSecColSubChildUnRegister
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            moduleName={'bpsi'}
                            allData={allData?.generalProbArr}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )) || (
                          <CounselingSecColSubChild
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            handleEditSubChild={handleEditSubChild}
                            moduleName={'bpsi'}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )}
                    </div>
                  ))}
              </div>
            ))}
          </div>
          <div className="mat-cnslng-col3">
            {allData?.therapyMasterData?.map((data, i) => (
              <div key={i} className="mat-cnslng-col3-rw">
                <span
                  className="pop-up-sb-hdr biopsycho-parnt-hdr"
                  style={{
                    backgroundColor: '#f3fafd',
                    fontSize: '14px',
                    paddingLeft: '15px',
                  }}
                >
                  {data[1]}
                </span>
                {data[2]?.map((subData, j) => (
                  <div key={j} className="mat-cnslng-col3-chld-rw grid-sec">
                    <div
                      className={
                        i === 0 && j === 0
                          ? 'grid-sec cnslng-actv-area'
                          : 'grid-sec'
                      }
                      ref={(el) =>
                        (scrollRefs.current[
                          'bpsiDetailsText_' + data[3] + '_' + subData[0]
                        ] = el)
                      }
                    >
                      <span className="pop-up-sb-hdr">{subData[1]}</span>
                      <textarea
                        className="cnslng-poup-txtrea"
                        placeholder="Write here..."
                        id={'bpsiDetailsText_' + data[3] + '_' + subData[0]}
                        name={'bpsiDetailsText_' + data[3] + '_' + subData[0]}
                        spellCheck="true"
                        value={
                          (textAreaData &&
                            textAreaData[
                              'bpsiDetailsText_' + data[3] + '_' + subData[0]
                            ]) ||
                          ''
                        }
                        onChange={handleTextAreaChange}
                      ></textarea>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="gnrl-dtl-btn-rw">
          {(allData.mode === 'add' && (
            <button className="actn-yes" onClick={handleBpsiFormSave}>
              Save
            </button>
          )) ||
            (allData.mode === 'update' && (
              <button className="actn-yes" onClick={handleBpsiFormUpdate}>
                Update
              </button>
            ))}
          <button className="actn-No" onClick={() => handleCloseFun()}>
            Cancel
          </button>
        </div>
        {subTypePopup && (
          <SubTypePopup
            closeDialog={() => setSubTypePopup(false)}
            subChildPrams={subChildPrams}
            callBack={handlesubtypeform}
            form={'bpsi'}
          />
        )}
        {removeSubChild && (
          <ConfirmDialog
            bodytext={'Do you want to remove it?'}
            closeDialog={() => setRemoveSubChild(false)}
            successDialog={handleRemoveSubChildConfirm}
            sucPrams={sucPrams}
          />
        )}
      </div>
    </div>
  );
}

export default BioPsychoSocialPopUp;
